import { render, staticRenderFns } from "./surgeOrderList.vue?vue&type=template&id=38553dc8&scoped=true"
import script from "./surgeOrderList.vue?vue&type=script&lang=js"
export * from "./surgeOrderList.vue?vue&type=script&lang=js"
import style0 from "./surgeOrderList.vue?vue&type=style&index=0&id=38553dc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38553dc8",
  null
  
)

export default component.exports